import React, {useEffect, useState} from 'react';

export const IsElementDisplayed = (element: any, rootMargin: string) => {
  const [isVisible, setState] = useState<boolean>(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setState(entry.isIntersecting);
      },
      {rootMargin},
    );
    const targetElement = element.current;

    // eslint-disable-next-line no-unused-expressions
    targetElement && observer.observe(targetElement);

    return () => observer.disconnect();
  }, []);

  return isVisible;
};

// Do-Not Use Handle Special Case
export const isElementInView = (element: any): boolean => {
  if (!element) {
    return false;
  }
  const rect = element.getBoundingClientRect();
  return (
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) + 200 &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

type UserAgent = 'iOS' | 'Android' | 'Windows Phone' | 'unknown';

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
export const getMobileOperatingSystem = (): UserAgent => {
  var userAgent = navigator.userAgent;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'iOS';
  }

  return 'unknown';
};
